var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.5,
    height: 20.504,
    viewBox: "0 0 20.5 20.504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304",
    transform: "translate(-5032.123 -3506.954)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303",
    transform: "translate(5032.168 3506.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6504",
    "data-name": "Path 6504",
    d: "M5043.349,3511.015v-.355c0-.949.006-1.9,0-2.848a.717.717,0,0,1,.4-.747.7.7,0,0,1,.824.191q2.008,1.8,4.019,3.592l3.632,3.252a.7.7,0,0,1,0,1.219q-3.815,3.411-7.633,6.821a.737.737,0,0,1-.853.2.709.709,0,0,1-.392-.75c.008-.949,0-1.9,0-2.848v-.351a8.537,8.537,0,0,0-2.393.318,10.145,10.145,0,0,0-5.961,4.879,12.877,12.877,0,0,0-1.328,3.171c-.149.547-.557.776-.989.568a.677.677,0,0,1-.388-.575,14.784,14.784,0,0,1,4.688-13.148,9.169,9.169,0,0,1,6.179-2.567C5043.205,3511.038,5043.253,3511.027,5043.349,3511.015Zm-9.734,12.164a.445.445,0,0,0,.074-.06c.048-.077.094-.155.14-.233a12.143,12.143,0,0,1,4.4-4.49,9.815,9.815,0,0,1,5.63-1.331c.612.038.838.277.839.869q0,.728,0,1.455v.834l6.164-5.511-6.172-5.506c0,.852,0,1.618,0,2.385,0,.543-.262.771-.8.8a12.754,12.754,0,0,0-1.925.17,9.4,9.4,0,0,0-5.677,3.7A13.53,13.53,0,0,0,5033.615,3523.178Z",
    transform: "translate(-5032.168 -3506.999)",
    fill: "#3067ae",
    stroke: "#3067ae",
    strokeWidth: 0.1,
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.baca026e27e988bf64a1d1b3f3b83033.svg";
export { ForwardRef as ReactComponent };